import React from "react"
import { Link } from "gatsby"

import * as styles from"./pagination.module.scss"

const Pagination = ({ pages, currentPage }) => {
	const paginationLength = 4
  const isFirst = currentPage === 1
  const isLast = currentPage === pages
  const prevPage = currentPage - 1 === 1 ? "" : (currentPage - 1).toString()
  const nextPage = (currentPage + 1).toString()

  let pageArray = []
  let intialPages = false
  let lastPages = false
  let startIndex = 0
  if (currentPage <= (paginationLength-1)) {
    startIndex = 1;
    intialPages = true;
  } else if (currentPage + (paginationLength-1) > pages) {
    startIndex = pages - paginationLength;
    lastPages = true;
  } else {
    startIndex = currentPage - 2
  }
  pageArray = [startIndex]

  if (!isLast) {
    for (let i = 1; i !== pages; i++) {
      pageArray = pageArray.concat([startIndex + i]);
    }
  } else {
    lastPages = true
  }

  return (
    <section className="bg-light py-40">
      <div className={styles.pagination}>
        {!isFirst && <Link to={prevPage !== "" ? `/${prevPage}/#all-articles`: "/"} rel="prev" />}
        {!intialPages && (
          <Link
            to={`/`}
            className={currentPage === 1 ? styles.active : ""}
          >
            {1}
          </Link>
        )}
        {!intialPages && <p to="">...</p>}
        {pageArray.map((k, i) => (
			(pages>k && k>currentPage-paginationLength&&k<currentPage+paginationLength?(
			  <Link
				to={`${k === 1 ? `/` : `/${k}/#all-articles`}`}
				key={k}
				className={currentPage === k ? styles.active : ""}
			  >
				{k}
          </Link>
		  ):"")
        ))}
        {!lastPages && pages > paginationLength && <p>...</p>}
        {!lastPages && pages > paginationLength && (
			pages<paginationLength?(
          <Link
            to={`/${pages}/#all-articles`}
            key={pages}
            className={currentPage === pages ? styles.active : ""}
          >
            {pages}
          </Link>
		  ):""
        )}
		
		<Link
			to={`/${pages}/#all-articles`}
			key={pages}
			className={currentPage === pages ? styles.active : ""}
		>
			{pages}
		</Link>
        {!isLast && <Link to={`/${nextPage}/#all-articles`} rel="next" />}
      </div>
    </section>
  )
}

export default Pagination
